import React from 'react';

import TableRow from './TableRow';

class TableBody extends React.PureComponent {
  render() {
    const {
      teamOrder,
      skillsOrder,
      members,
      scores,
      hoverIndex,
      itemLabel,
      onCreatePlan,
      location,
      startDate,
      endDate,
    } = this.props;
    // Create one row per member in members
    const rows = teamOrder.map(id => (
      <TableRow
        key={id}
        location={location}
        nameClick={this.props.nameClick}
        totalsClick={this.props.totalsClick}
        scores={scores.get(id)}
        item={members.get(id)}
        hoverIndex={hoverIndex}
        updateHoverIndex={this.props.updateHoverIndex}
        rowTooltip={this.props.rowTooltip}
        itemLabel={itemLabel}
        registerPopoverItem={this.props.registerPopoverItem}
        onCreatePlan={onCreatePlan}
        startDate={startDate}
        endDate={endDate}
        {...{skillsOrder}}
      />
    ));

    return <tbody>{rows}</tbody>;
  }
}

TableBody.displayName = 'SAW-TableBody';
export default TableBody;
